'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _reactRouter = require('react-router');

var _Search = require('components/Search');

var _constants = require('redux/constants');

require('./Search.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    SearchView: {
        displayName: 'SearchView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Search/default/SearchView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var SearchView = _wrapComponent('SearchView')(function (_Component) {
    (0, _inherits3.default)(SearchView, _Component);

    function SearchView(props, context) {
        (0, _classCallCheck3.default)(this, SearchView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SearchView.__proto__ || (0, _getPrototypeOf2.default)(SearchView)).call(this, props, context));

        _this._loader = null;


        _this.state = {
            isShow: false
        };
        return _this;
    }

    (0, _createClass3.default)(SearchView, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var className = 'search-area';

            if (this.state.isShow && this.props.searchProducts.length) {
                className += ' show';
            }

            return _react3.default.createElement(
                'div',
                { className: 'top-search-holder' },
                _react3.default.createElement(
                    'div',
                    { className: className },
                    _react3.default.createElement(
                        'form',
                        null,
                        _react3.default.createElement(
                            'div',
                            { className: 'control-group', style: { position: 'relative' } },
                            _react3.default.createElement(_Search.Autocomplete, {
                                onChange: this.props.handleChangeInput,
                                onKeyPress: this.props.handleEnter,
                                classNameInput: 'search-field',
                                placeholderInput: this.props.lang['store.search.product_search'],
                                typeInput: 'search',
                                onSelect: this.props.onSelect,
                                classMenu: 'search-menu',
                                loader: this._loader,
                                onShow: function onShow(isShow) {
                                    _this2.setState({ "isShow": isShow });
                                }
                            }),
                            _react3.default.createElement(
                                'div',
                                { className: 'search-loader', ref: function ref(element) {
                                        _this2._loader = element;
                                    } },
                                _react3.default.createElement('img', { src: '/assets/images/' + this.props.theme + '.svg', alt: '' })
                            ),
                            _react3.default.createElement('a', {
                                href: '#',
                                onClick: this.props.handleClick,
                                className: 'search-button'
                            }),
                            _react3.default.createElement('div', { style: { clear: 'both' } })
                        )
                    )
                ),
                this.props.loyaltySettingsActive ? _react3.default.createElement(
                    'div',
                    { className: 'text-right' },
                    _react3.default.createElement(
                        'a',
                        { onClick: this.props.onFindCoupon },
                        this.props.lang['store.iBonus.i_have_a_coupon']
                    )
                ) : null
            );
        }
    }]);
    return SearchView;
}(_react2.Component));

exports.default = SearchView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/default/SearchView.jsx
// module id = 1765
// module chunks = 0